export const SESSION_EXPIRATION = 900;

export const SESSION_REFRESH_MODAL_DELAY = 10;